// extracted by mini-css-extract-plugin
export var actionText = "_pk-4";
export var container = "_pk-0";
export var leftSection = "_pk-1";
export var rightSection = "_pk-2";
export var settingsButton = "_pk-6";
export var settingsIcon = "_pk-7";
export var shortcut = "_pk-5";
export var shortcutGroup = "_pk-3";